import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";


@Kbo(CToken.OverlayPopupControl)
export class OverlayPopupControl extends UiObject {

    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public padding: string;

    public allowedChildren(rootType: CToken) {
        if (rootType == CToken.Configurator) {
            return [
                CToken.OverlayPopup
            ]
        } else {
            return [];
        }
    }
}
